import { Text, neutral } from "@flat-ui";
import { Box } from "@mui/material";
import { PropsWithChildren } from "react";

interface Props {
  /** Title text displayed above the step's input controls. */
  title: string;

  /** Subtext displayed below the title and above the step's input controls. */
  subtext?: string;
}

/** Shared layout that renders a step's title and subtext above its input controls. */
export function AnalyticsFeedbackStepLayout({
  title,
  subtext,
  children,
}: PropsWithChildren<Props>): JSX.Element {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Text variant="heading16">{title}</Text>
        <Text variant="bodyM" color={neutral[600]}>
          {subtext}
        </Text>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {children}
      </Box>
    </Box>
  );
}
